import type { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { responsiveFontSize } from '@presentation/styles';
import { FaTimesCircle } from 'react-icons/fa';
import type { TypeOptions } from 'react-toastify';
import { Button } from '..';

export const toastTypeColor = (theme: Theme) =>
  ({
    error: theme.color.red.default,
    success: theme.color.green.default,
    info: theme.color.dark.default,
  } as Record<TypeOptions, string>);

export const ToastTopBar = styled.div<{ type: TypeOptions }>`
  position: absolute;
  left: -24px;
  right: -24px;
  top: -28px;
  height: 6px;
  background: ${(props) => toastTypeColor(props.theme)[props.type]};
`;

export const ToastTitle = styled.h3<{ fontSize?: number }>`
  font-weight: 900;
  ${(props) => responsiveFontSize(props.fontSize ?? 24, 1)}
  margin-bottom: 5px;
`;

export const ToastButton = styled(Button)`
  margin-top: 10px;
  margin-bottom: 5px;
`;

export const ToastCloseButton = styled(FaTimesCircle)`
  height: 20px;
  width: : 20px;
  position: absolute;
  right: 18px;
  top: 18px;
`;
